/*
*###############################################################################
*Module Name                   : WMSBinMaster.js                               #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Thursday, Novermber 30th 2023, 10:14:01 am    #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import WMSBinMasterContent from './WMSBinMasterContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Numeric, Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import DPPrintOption from 'framework/widgets/DPPrintOptions'
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { BinDetailsGetData, DeleteBinDetails, GetBinZones, SaveBinDetails, SaveDesignationListDetails } from './WMSBinController'

const WMSBinMaster = (props) => {

    let history = useHistory();

    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
    } = useContext(Context);

    //*** User input related states */
    const [binZone, SetBinZone] = useState("");
    const [binAisle, SetBinAisle] = useState("")
    const [binRack, SetBinRack] = useState("")
    const [binBay, SetBinBay] = useState("")
    const [binLevel, SetBinLevel] = useState("")
    const [binId, SetBinId] = useState("")
    const [capacity, setCapacity] = useState(0)
    const [IsActive, SetActive] = useState(true)
    const [menuCode, SetMenuCode] = useState("")
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledBinId, setDisabledBinId] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState("")
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*** Get and Set values when user search code */

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)

    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);

    const [currentPage, setCurrentPage] = useState(1)
    const [Disable, setDisable] = useState(false)
    const [zoneList, setZoneList] = useState([])
    const [helpUrl, setHelpUrl] = useState("")
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    //import from contexts
    var time = process.env.REACT_APP_ALERTTIMEOUT

    //**Get File Details */
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]

        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName

        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        if (!responseData.strMenuAccessRight) {
            history.push('/dashboard')
        }

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)
        setHelpUrl(responseData.strHelpUrl)
        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

        const { success, data } = await GetBinZones(LogUserType,LocationCode);
        if (success) {
            setZoneList(data)
        }


    }, [binZone])

    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu =
            menuDetail && menuDetail.menuTag
                ? menuDetail.menuTag
                : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
    }, [])


    async function getData(binId) {

        if (binId == "") return

        if (binId.length !== 13) {
            displayAlertMessage('danger', "Invalid Bin ID !")
            SetBinId("")
            return
        }

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Fetching...")

        const result = await BinDetailsGetData(binId);

        SetLoadingAlert(false)

        if (result.success == true) {

            SetBinZone(result.data.binZone)
            SetBinAisle(result.data.binAisle)
            SetBinRack(result.data.binRack)
            SetBinBay(result.data.binBay)
            SetBinLevel(result.data.binLevel)
            SetActive(result.data.binActive)
            setCrBy(result.data.createdBy)
            setCrDate(result.data.createdDate)
            setMdBy(result.data.modifiedBy)
            setMdDate(result.data.modifiedDate == "1900-01-01T00:00:00" ? "" : result.data.modifiedDate)
            setCapacity(result.data.capacity)
            setCrEnable(true)

            let modifiedRows = [];

            result.data.zones.map((zone) => {
                modifiedRows.push({
                    id: modifiedRows.length + 1,
                    code: zone.strBIND_ZONE,
                    desc: zone.dcBIND_DISTANCE,
                });
            });

            setarRow(modifiedRows.length === 0 ? [{ id: 1 }] : modifiedRows);

            setDisabled(true)
            setDisabledBinId(true)
            setSaveEnable(false)
            SetAddNew(false)
            SetDeleteEnable(true)
            setSearchdisabled(true)
            setReason("Updated")
            SetEditEnable(false)

            detTableController(true)

        }
        else {
            if (nullCode == false) {
                displayAlertMessage('success', "Record Not Found !")
            } else {
                displayAlertMessage('success', "Record Not Found !")
            }
        }

    }

    //*** End useEffect */

    // print Function
    async function handlePrint(option) {
        var option = option
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/designation/report/${LogUserType}/${option == "PDF" ? 1 : 0}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (option == "PDF") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                    if (option == "XCEL") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                    }

                }
                SetLoadingAlert(false)
            }).catch(error => {
                console.log(error.message)
                SetLoadingAlert(false)
            })
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    function stringToBool(value) {
        value = value.toString().toLowerCase();
        return value === "1" || value === "true"

    }

    //save button function
    const handlesave = async (e) => {
        var ExcelItemsRows = [...Excelitems]
        if (Array.isArray(ExcelItemsRows) && ExcelItemsRows.length) {
            var saveList = []
            ExcelItemsRows.map(async (localState) => {
                if ((localState.Code != null) && (localState.Description != null) && (localState.Active != null) || !localState.Active) {
                    saveList.push({
                        DesignationCode: localState.Code,
                        DesignationDesc: localState.Description,
                        IsActive: stringToBool(localState.Active),
                    })
                }
            })

            const designationArray = {
                DesignationList: saveList,
                User: LogUserType,
                MenuCode: menuCode,
                LoggedCompany: LogCompanyCode,
                LoggedLocation: LocationCode,
                Reason: Reason,
                CreateBy: LogUserType,
            }

            var response = await SaveDesignationListDetails(designationArray);

            if (response.success) {
                displayAlertMessage("success", response.message)

                var autoCodeRes = await fetchAutoCode(menuCode)
                setExcelItems([]);
                setvalueUpload("");

                if (autoCodeRes.nullCode == false) {
                    setAutoCode(autoCodeRes.autoCode)

                } else {
                    setNullCode(true)
                    setAutoCode("")
                }

            } else {
                displayAlertMessage("danger", response.message)
            }

        } else {

            //set autogenerate code to as CODE just for display purpuse
            // if (addNew == true && nullCode == false) {
            //     SetBinId(autoCode)
            // }

            if (binId == "") {
                displayAlertMessage('danger', "Please Enter Bin ID !")
                return;
            }

            if (binId.length !== 13) {
                displayAlertMessage('danger', "Bin Id is Invalid !")
                ClearItem()
                return
            }

            if (binZone == "") {
                displayAlertMessage("danger", "Please Enter Bin Zone !")
                return;
            }
            if (binAisle == "") {
                displayAlertMessage('danger', "Please Enter Bin Aisle !")
                return;
            }

            if (binRack == "") {
                displayAlertMessage('danger', "Please Enter Bin Rack !")
                return;
            }

            if (binBay == "") {
                displayAlertMessage('danger', "Please Enter Bin Bay !")
                return;
            }

            if (binLevel == "") {
                displayAlertMessage('danger', "Please Enter Bin Level !")
                return;
            }

            var ActiveStat = IsActive == true ? 1 : 0; //checking active status

            var payDet = [];

            // for (var i = 0; i < arRow.length; i++) {

            //     if (arRow[i].code != "") {
            //         if (arRow[i].code.length == 5) {
            //             if (arRow[i].desc != "") {
            //                 payDet.push(PayDetBuilder(arRow[i].code, arRow[i].desc))
            //             } else {
            //                 displayAlertMessage('danger', " Details distance is empty in Details type table row number " + (i + 1) + " !")
            //                 return;
            //             }
            //         } else {
            //             displayAlertMessage('danger', " Details zone is invalid in Details type table row number " + (i + 1) + " !")
            //             return;
            //         }
            //     } else {
            //         displayAlertMessage('danger', " Details zone is empty in Details type table row number " + (i + 1) + " !")
            //         return;
            //     }
            // }

            const BinDetails = {
                "binZone": binZone,
                "binAisle": binAisle,
                "binRack": binRack,
                "binBay": binBay,
                "binLevel": binLevel,
                "binId": binId,
                "binActive": ActiveStat,
                "M_TBLBINZONEDISTANCE": payDet,
                "strMenuCode": menuCode,
                "strLoggedCompany": LogCompanyCode,
                "strLoggedLocation": LocationCode,
                "strReason": Reason,
                "strCreateBy": LogUserType,
                "blAddNew": addNew,
                "capacity": parseFloat(capacity)
            }

            //loading alert show
            SetLoadingAlert(true)
            if (addNew == true) {
                SetLoadingAlerttitle("Saving...")
            } else {
                SetLoadingAlerttitle("Updating...")
            }

            const result = await SaveBinDetails(BinDetails);

            SetLoadingAlert(false)

            if (result.success) {
                displayAlertMessage('success', result.data)
                ClearItem()

            }
            else {
                displayAlertMessage('danger', result.data)
                setCodeButton(false)
            }
        }
    }

    //***save/update end */

    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetBinId(row.BIN_ID);
        getData(row.BIN_ID)
        // SetBinZone(row.BIN_ZONE)
        // SetBinAisle(row.BIN_AISLE)
        // SetBinRack(row.BIN_AISLE)
        // SetBinBay(row.BIN_BAY)
        // SetBinLevel(row.BIN_LEVEL)
        // SetActive(row.BIN_ACTIVE)
        setDisabled(true)
        setDisabledBinId(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)
    }
    //*** End of getSelectedRow function */

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledBinId(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
        detTableController(false)
    }

    //new button function
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetBinId("")
        SetBinZone("")
        SetBinAisle("")
        SetBinRack("")
        SetBinBay("")
        SetBinLevel("")
        setCapacity(0)
        SetActive(true)
        setDisabledBinId(false)
        setDisabled(false)
        setCrEnable(false)
        setErrorMsg('')
        SetAddNew(true)
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setSaveEnable(true)
        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setExcelItems([])
        setarRow([{
            id: 1,
            code: "",
            desc: "",
        }])
        detTableController(false)
        setTimeout(() => {
            setExcelItems([])
        }, 1)
    }

    //********Delete button function */

    const handleDelete = async () => {

        const rowDelete = {
            "strMenuCode": menuCode,
            "binZone": binZone,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        const result = await DeleteBinDetails(rowDelete);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage('success', result.data)
            ClearItem()
        }
        else {
            displayAlertMessage('warning', result.data)
        }
    }

    //*********Delete button function end */

    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetBinZone(responseData.data)
                    } else {
                        setDisabledBinId(false)
                    }
                }
            })
    }

    //**Permission Check */
    const permission = (operation) => {
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs() //clear username & password

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledBinId(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "Oops something went wrong !")
            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledBinId(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "You have not Permission to make changes !")
            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledBinId(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "Password or User Name is Invalid !")
            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }

    //Function for displaying Alert Messages.S
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }

    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }

    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }

    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }

    /*****Create Bin ID using values user entered for zone, aisle, rack, bay, level values***/
    const CreateBinID = (zone, aisle, rack, bay, level) => {
        if (zone == "00000") {
            displayAlertMessage('danger', 'Please Enter a Valid Zone Id !')
            zone = ""
            SetBinZone(zone)
        }

        if (aisle == "00") {
            displayAlertMessage('danger', "Please Enter a Valid aisle Id !")
            aisle = ""
            SetBinAisle(aisle)
        }

        if (rack == "00") {
            displayAlertMessage('danger', "Please Enter a Valid Rack Id !")
            rack = ""
            SetBinRack(rack)
        }

        if (bay == "00") {
            displayAlertMessage('danger', "Please Enter a Valid Bay Id !")
            bay = ""
            SetBinBay(bay)
        }

        if (level == "00") {
            displayAlertMessage('danger', "Please Enter a Valid Level Id !")
            level = ""
            SetBinLevel(level)
        }

        SetBinId(`${zone}${aisle}${rack}${bay}${level}`)
    };

    /***Validate zone, aisle, rack, bay, level with their required lenghts & alphanumericRegex.*/
    const validateBinId = (value, maxLength) => {
        const alphanumericRegex = /^[a-zA-Z0-9]+$/

        if (alphanumericRegex.test(value) !== true) {
            displayAlertMessage('danger', "Invalid !!!")
            return null
        }

        if (value.length < maxLength) {
            return null
        }

        return value
    }

    const [arRow, setarRow] = useState([{
        id: 1,
        code: "",
        desc: "",
    }])

    const PayDetBuilder = (txtzone, txtdist) => {
        return {
            "strBIND_ZONE": txtzone,
            "dcBIND_DISTANCE": parseFloat(txtdist),
        }
    }

    const detTableController = (disabled) => {
        var tbl = document.getElementById("wmsBinDet");
        if (tbl != null) {
            let rowCount = tbl.tBodies[0].rows.length;
            for (let i = 0; i < rowCount; i++) {
                document.getElementById("txtzone" + i).disabled = disabled
                document.getElementById("txtdist" + i).disabled = disabled
            }
        }
    }

    // function handleAddRowNested() {
    //     const modifiedRows = [...arRow]
    //     modifiedRows.push({ id: modifiedRows.length + 1 })
    //     setarRow(modifiedRows)
    // }

    // function handleRemoveRow(id) {
    //     if (id !== 0) {
    //         var modifiedRows = [...arRow]
    //         modifiedRows = modifiedRows.filter(x => x["id"] !== id)
    //         setarRow(modifiedRows)
    //     }
    // }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {

                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                history.push('/dashboard')
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs() //clear password and username
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <WMSBinMasterContent
                                            GetSelectRow={GetSelectRow}
                                            menuName={menuName}
                                            menuCode={menuCode}
                                            binId={binId}
                                            binIdOnChange={e => {
                                                let id = Text(
                                                    e.target,
                                                    13,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetBinId(id)
                                            }}
                                            binIdOnBlur={e => {
                                                getData(e.target.value)
                                            }}
                                            searchdisabled={searchdisabled}
                                            tog_xlarge={tog_xlarge}
                                            binZone={binZone}
                                            binZoneOnChange={e => {
                                                let selectedVal = e["value"]
                                                let zone = validateBinId(String(selectedVal).padStart(5, '0'), 5)
                                                if (zone !== null) {
                                                    SetBinZone(zone);
                                                    CreateBinID(zone, binAisle, binRack, binBay, binLevel)
                                                } else {
                                                    SetBinZone("")
                                                }
                                            }}
                                            binAisle={binAisle}
                                            binAisleOnChange={e => {
                                                let aisle = Text(
                                                    e.target,
                                                    2,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetBinAisle(aisle)
                                            }}
                                            binAisleOnBlur={e => {
                                                let aisle = validateBinId(e.target.value.padStart(2, '0'), 2)
                                                if (aisle !== null) {
                                                    SetBinAisle(aisle);
                                                    CreateBinID(binZone, aisle, binRack, binBay, binLevel)
                                                } else {
                                                    SetBinAisle("")
                                                }
                                            }}
                                            binRack={binRack}
                                            binRackOnChange={e => {
                                                let rack = Text(
                                                    e.target,
                                                    2,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetBinRack(rack)
                                            }}
                                            binRackOnBlur={e => {
                                                let rack = validateBinId(e.target.value.padStart(2, '0'), 2)
                                                if (rack !== null) {
                                                    SetBinRack(rack);
                                                    CreateBinID(binZone, binAisle, rack, binBay, binLevel)
                                                } else {
                                                    SetBinRack("")
                                                }
                                            }}
                                            binBay={binBay}
                                            binBayOnChange={e => {
                                                let bay = Text(
                                                    e.target,
                                                    2,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetBinBay(bay)
                                            }}
                                            binBayOnBlur={e => {
                                                let bay = validateBinId(e.target.value.padStart(2, '0'), 2)
                                                if (bay !== null) {
                                                    SetBinBay(bay);
                                                    CreateBinID(binZone, binAisle, binRack, bay, binLevel)
                                                } else {
                                                    SetBinBay("")
                                                }
                                            }}
                                            binLevel={binLevel}
                                            binLevelOnChange={e => {
                                                let level = Text(
                                                    e.target,
                                                    2,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetBinLevel(level)
                                            }}
                                            binLevelOnBlur={e => {
                                                let level = validateBinId(e.target.value.padStart(2, '0'), 2)
                                                if (level !== null) {
                                                    SetBinLevel(level);
                                                    CreateBinID(binZone, binAisle, binRack, binBay, level)
                                                } else {
                                                    SetBinLevel("")
                                                }
                                            }}
                                            capacityOnChange={e => {
                                                let capacity = Numeric(e.target, 10, true, false)
                                                setCapacity(capacity)
                                            }}
                                            capacity={capacity}
                                            capacityOnBlur={e => {
                                                let capacity = Numeric(e.target, 10, true, false)
                                                if (e.target.value == "") {
                                                    setCapacity(0)
                                                } else {
                                                    setCapacity(capacity)
                                                }
                                            }}
                                            IsActive={IsActive}
                                            switchOnChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            show={show}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            ErrorMsg={ErrorMsg}
                                            disabled={disabled}
                                            zoneList={zoneList}
                                        />
                                    </Row>
                                    {/* <Row>
                                        <WMSBinTableContent
                                            DataRow={arRow}
                                            setarRow={setarRow}
                                            //RemoveRow={handleRemoveRow}
                                            //AddRow={handleAddRowNested}
                                            Disable={disabled}
                                            menuCode={menuCode}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    </Row> */}
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default WMSBinMaster